/* eslint jsx-a11y/no-redundant-roles: 0 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, Heading, CallToAction } from '@scentregroup/ui'
import { uniqueId } from 'lodash'
import { Link } from 'react-router-dom'
import DeckScrollWrapper from '../deck-scroll-wrapper'
import WhatsOnFilters from '../whats-on-filters'
import showWhatsOnFilter from '../../helpers/show-whats-on-filter/index'
import analyticsUtils from '../../helpers/analytics-utils'
import { CONFIG_KEYS, getClientConfigBool } from '../../helpers/config-helper'
import EventNotification from '../event-notification'
import style from './index.scss'
import DeckCard from './deck-card'
import {
  trackDeckCTAClick,
  trackDeckDateRangeClick,
  trackPromotionClickEvent,
} from './analytics'

class Deck extends Component {
  state = {
    selectedFilter: '',
  }

  componentDidMount() {
    const { children } = this.props
    if (
      children &&
      children.length &&
      !getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT)
    ) {
      this.trackVisibleItems(children)
    }
  }

  isWhatsHappeningFiltersEnabled = getClientConfigBool(
    CONFIG_KEYS.NEXT_PUBLIC_TOGGLE_WHATS_ON_DECK_FILTERS
  )

  trackVisibleItems = items => {
    const cards = items.map(c => c.props)
    const promotions = cards.map(i => ({
      id: i.id,
      name: i.title,
      position: analyticsUtils.positions.WHATS_HAPPENING_CENTRE,
      dimension90: analyticsUtils.dimensions.DIMENSION90,
      creative: i.body,
    }))

    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PROMOTION_IMPRESSION,
      ecommerce: {
        promoView: {
          promotions,
        },
      },
    })
  }

  render() {
    const {
      children,
      color,
      title,
      centre,
      callToActionLabel,
      callToActionAddress,
    } = this.props
    const { selectedFilter } = this.state
    const id = uniqueId('deck-')
    const whatsOnContentId = 'whats-on-content'
    const showCTA = callToActionLabel && callToActionAddress

    return (
      <Container type="large" className={style.deckContainer}>
        <div className={style.deckFiltersContainer}>
          {this.isWhatsHappeningFiltersEnabled ? (
            <>
              <Heading type="large" className={style.heading} id={id}>
                {title}
              </Heading>
              {centre && showWhatsOnFilter(centre.status) && (
                <div
                  aria-controls={whatsOnContentId}
                  className={style.whatsOnNav}
                >
                  <WhatsOnFilters
                    navigatable
                    showHeading={false}
                    selectedFilter={selectedFilter}
                    handleFilters={this.handleFilter}
                    contentId={whatsOnContentId}
                    centre={centre}
                    classNames={style.whatsOnNavItem}
                    onClick={filter => trackDeckDateRangeClick(filter.name)}
                  />
                </div>
              )}
            </>
          ) : (
            <Heading type="large" className={style.heading} id={id}>
              {title}
            </Heading>
          )}
        </div>
        <EventNotification className={style.warningNotification} />
        <DeckScrollWrapper
          className={style.contentWrapper}
          bgColor={color}
          eventCategory={analyticsUtils.categories.WHATS_HAPPENING_CENTER}
          eventAction={analyticsUtils.actions.CLICK}
        >
          <ol className={style.deckCardList} aria-labelledby={id} role="list">
            {React.Children.map(children, child =>
              React.cloneElement(child, {
                className: style.deckCard,
                onClick: () => trackPromotionClickEvent(child.props),
              })
            )}
          </ol>
        </DeckScrollWrapper>
        {showCTA && centre && (
          <CallToAction
            element={Link}
            to={`/${centre.slug}/${callToActionAddress}`}
            className={style.callToAction}
            inverted={color === 'Seasonal'}
            onClick={() => trackDeckCTAClick(callToActionLabel)}
          >
            {callToActionLabel}
          </CallToAction>
        )}
      </Container>
    )
  }
}

Deck.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  centre: PropTypes.object,
  callToActionLabel: PropTypes.string,
  callToActionAddress: PropTypes.string,
}

export { Deck, DeckCard }
